import { Textbox } from "..";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export interface DynamicDbDisplayValueSearchListener extends EventListener {
    (event: DynamicDbDisplayValueSearchEvent): void;
}

export class DynamicDbDisplayValueSearchEvent extends Event {
    private _addlValues: any = {};

    constructor(target: Textbox, domEvent?: DomEvent) {
        super(target, domEvent);
    }

    public override get target(): Textbox {
        return super.target as Textbox;
    }

    public get addlValues(): any {
        return this._addlValues;
    }

    public set addlValues(value: any) {
        this._addlValues = value;
    }

    public addAddlValue(key: string, value: any) {
        this.addlValues[key] = value;
    }
}
